import React from "react";
import "./Privacy.css";
import { IoIosArrowBack } from "react-icons/io";

export default function Privacy() {
  return (
    <div className="privacy-wrapper mt-5">

      {/* ======= HEADER ======= */}
      <div className="privacy-header mt-5">
        <IoIosArrowBack size={26} className="privacy-back-icon mt-5" />
        <h2>سياسة الخصوصية</h2>
      </div>

      {/* ======= CONTENT ======= */}
      <div className="privacy-content">

        <p>
          <strong>سياسة الخصوصية لتطبيق طوق النجاة</strong> تلتزم في طوق النجاة بحماية خصوصية مستخدمينا وضمان سرية بياناتهم الشخصية. تهدف هذه السياسة إلى توضيح كيفية جمع واستخدام وحماية المعلومات الخاصة بك أثناء استخدامك لتطبيقنا أو موقعنا الإلكتروني.
        </p>

        <p>
          <strong>جمع المعلومات:</strong> نقوم بجمع بعض المعلومات الضرورية لتحسين تجربة الاستخدام مثل الاسم، رقم الجوال، البريد الإلكتروني، وموقعك الجغرافي. يتم جمع هذه البيانات بموافقتك فقط، ولا نشاركها مع أي جهة خارجية دون إذن مسبق.
        </p>

        <p>
          <strong>استخدام المعلومات:</strong> نستخدم المعلومات التي يتم جمعها لتحسين خدماتنا، تخصيص المحتوى، إرسال إشعارات، دعم المستخدمين داخل التطبيق، كما نستخدمها لتطوير أداء النظام ودعم التواصل بين المستخدمين.
        </p>

        <p>
          <strong>حماية المعلومات:</strong> نستخدم أحدث التقنيات والإجراءات الأمنية لضمان حماية بياناتك من الوصول غير المصرح به أو التعديل أو الإفصاح. يتم تخزين البيانات في بيئة آمنة وتراجع أنظمة الحماية بشكل دوري.
        </p>

        <p>
          <strong>الكوكيز وملفات التتبع:</strong> قد نستخدم ملفات تعريف الارتباط (Cookies) لتحسين تجربة المستخدم وتخصيص المحتوى. يمكنك اختيار تعطيل هذه الملفات من إعدادات متصفحك، لكن قد يؤثر ذلك على بعض خصائص التطبيق.
        </p>

        <p>
          <strong>حقوق المستخدم:</strong> يحق لك الوصول إلى بياناتك الشخصية أو تعديلها أو حذفها متى شئت، وذلك عبر إعدادات الحساب أو التواصل مع فريق الدعم.
        </p>

        <p>
          <strong>تحديثات سياسة الخصوصية:</strong> نحتفظ بحق تعديل أو تحديث هذه السياسة من وقت لآخر بما يتناسب مع التطورات التقنية والقانونية. سيتم إشعار المستخدمين في حال وجود أي تغييرات مهمة عبر التطبيق أو البريد الإلكتروني.
        </p>

        <p>
          <strong>التواصل معنا:</strong> في حال وجود أي استفسارات أو ملاحظات حول سياسة الخصوصية، يمكنكم التواصل معنا عبر البريد الإلكتروني الرسمي أو صفحة “اتصل بنا” داخل التطبيق.
        </p>

        <p className="thanks">نشكركم على ثقتكم بطوق النجاة، ونسعى دائماً لتوفير بيئة رقمية آمنة.</p>

      </div>
    </div>
  );
}
